module.exports = __webpack_public_path__ + "static/media/img-126.09a964b8.jpg";